import { render, staticRenderFns } from "./SelectOrderReason.vue?vue&type=template&id=72864699&scoped=true&"
import script from "./SelectOrderReason.vue?vue&type=script&lang=js&"
export * from "./SelectOrderReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72864699",
  null
  
)

export default component.exports